<template>
  <v-card flat class="catalog-list mb-2" width="auto">
    <ul>
      <li>
        <v-layout  align-center>
          <v-tooltip v-if="parts[0].name !== 'NO HAY TIPOS DE PARTES DISPONIBLES'" color="primary" top class="">
            <span  slot="activator" class="mr-2 primary--text"  v-html="renderAllIconsUnique(parts)" @click="toggleAllSelectedUnique(parts)"></span>
            <span>{{ this.toggleSelectedIcon === false ? $t('Catalog.List.PartTypes.SelectAll') : $t('Catalog.List.PartTypes.Deselected') }}</span>
          </v-tooltip>
          <v-tooltip v-if="parts[0].name === 'NO HAY TIPOS DE PARTES DISPONIBLES'" color="primary" top class="">
            <span slot="activator" class="mr-2 primary--text"  v-html="renderNotIconsUnique()"></span>
            <span>No hay partes disponibles</span>
          </v-tooltip>

          <v-flex class="px-2 py-2" align-center style="white-space: normal !important; word-wrap: break-word">
            <strong>{{ title }}</strong>                
          </v-flex>
          <v-flex shrink class="pb-2 pt-2">
            <v-btn @click="showContent()" icon class="action primary--text text-xs-center pa-1">
              <v-icon v-show="this.show === false">expand_more</v-icon>
              <v-icon v-show="this.show === true">expand_less</v-icon>
            </v-btn>
            <!-- <v-btn @click="resetUniquePartDescriptions()" icon class="action primary--text text-xs-center pa-1">
                    <v-tooltip color="orange" top>
                      <v-icon slot="activator" class="" medium>clear_all</v-icon>
                      <span>Resetear</span>
                    </v-tooltip> 
                  </v-btn> -->
          </v-flex>
        </v-layout>
      </li>
    </ul>
    <v-divider></v-divider>
    <ul v-show="this.show">
      <li v-for="part in parts" :key="`${part.name}-${part.id}`" @mouseenter="handlePreview(part)" :class="[{ 'active': inPartsBasketUnique(part) }]" >
        <v-layout v-if="part.name !== 'NO HAY TIPOS DE PARTES DISPONIBLES'" align-center>
          <span class="mr-2 primary--text"  v-html="renderIconUnique(part)"
            @click="toggleSelectedUnique(part)"></span>
          <v-flex class="px-2 py-2" @click="toggleSelectedUnique(part)" align-center
            style="white-space: normal !important; word-wrap: break-word">
             {{ part.name.replace(/[, ]+/g, " ") }}
          </v-flex>
          <v-flex shrink class="pb-2 pt-2">
            <button @click="go(part)" class="action white--text text-xs-center pa-1 primary">
              <small>{{ $t("Catalog.go") }}</small>
            </button>
          </v-flex>
        </v-layout>
        <v-layout  v-if="part.name === 'NO HAY TIPOS DE PARTES DISPONIBLES'" align-center>
          <span class="mr-5 primary--text"></span>
          <v-flex class="px-3 py-3" align-center
            style="white-space: normal !important; word-wrap: break-word">
            {{ part.name.replace(/[, ]+/g, " ") }}
          </v-flex>
        </v-layout>
      </li>
    </ul>
    <v-divider></v-divider>
  </v-card> 
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "ListCatalogParts",
  data(){
    return {
      show: true,
      toggleSelectedIcon: false,
      showUniqueParts: false,
      uniquepartDescriptions: [],
    }
  },
  props: {
    parts: {
      type: Array,
      required: true
    },
    groups: {
      type: Object,
      required: true
    },
    title: {
      type: String
    },
    helperObject: {
      type: Object,
      required: false
    },
    listTarget: {
      type: Array
    },
    listType: {
      type: String
    },
    // Vuex state name
    model: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      basicCatalogRequest: 'parts/basicCatalogRequest',
      toggleSelectedIconBoolean:'parts/toggleSelectedIconBoolean',
      vehicleForInquiry: 'vehicle/vehicleForInquiry',
      onlyGroups: 'parts/onlyGroups',
      totalPartBasketCount: 'parts/totalPartBasketCount'
    }),
    ...mapState({
      skin: state => state.settings.skin,
      toggle: state => state.parts.toggleSelectedIcon,
      partsBasket: state => state.parts.partsBasket,
      // uniquepartDescriptions: state => state.parts.uniquepartsDescriptions
    })
  },
  methods: {
    ...mapActions({
      TOGGLE_SELECTION_SINGLE_PARTS_TYPES: "parts/TOGGLE_SELECTION_SINGLE_PARTS_TYPES",
      TOGGLE_SELECTION_ALL_PARTS_TYPES: "parts/TOGGLE_SELECTION_ALL_PARTS_TYPES",
      INQUIRY: "parts/INQUIRY",
      ACTIVE_PART_TYPES_ICON: "parts/ACTIVE_PART_TYPES_ICON",
      GET_UNIQUE_PART_DESCRIPTIONS: "parts/GET_UNIQUE_PART_DESCRIPTIONS",
      RESET_PARTS_TYPES: "parts/RESET_PARTS_TYPES",
      SET_UNIQUE_PART_DESCRIPTIONS_ARRAY: "parts/SET_UNIQUE_PART_DESCRIPTIONS_ARRAY",
      RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY: "parts/RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY"
    }),
    renderIcon(part) {
      return this.inPartsBasket(part)
        ? ('<i aria-hidden="true" class="v-icon material-icons">check_box</i>')
        : ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
    },
    renderIcons(parts){
      return this.inPartsBasketAll(parts)
        ? ('<i aria-hidden="true" class="v-icon material-icons">indeterminate_check_box</i>')
        : ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
    },
    
    inPartsBasket(part) {
      return (this.$store.state.parts[this.model].findIndex((i => i.id === part.id))) !== -1
    },
   
    inPartsBasketAll(parts){
      let count = 0;
      let partcount = 0
      parts.forEach(part => {
        const index = this.$store.state.parts[this.model].findIndex((i => i.id === part.id));
        if(index !== -1) {
          const partCountFinal = ++partcount
          count = partCountFinal
        }
      })
      if(count === parts.length){
        this.toggleSelectedIcon = true
        return true 
      } else {
        this.toggleSelectedIcon = false
        return false
      }
    },

    select(part) {
      this.$emit("SelectFn", { category: this.helperObject, part });
    },
    preview(params) {
      this.$emit("PreviewFn", params);
    },
    handlePreview(group) {
      if (this.listType == "group") this.preview(group);
    },
    toggleSelected(part) {
      const type = 'normal'
      this.$emit("click", { model: this.model, part, type });
    },
    toggleAllSelected(parts) {
      if(this.toggleSelectedIcon === false) {
        const type = 2
        const typeUnique = false
        const uniquepartDescriptions = []
        this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket', parts, uniquepartDescriptions, type, typeUnique});        
      } else if (this.toggleSelectedIcon === true){ 
        const type = 3
        const typeUnique = false
        const uniquepartDescriptions = []
        this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket', parts, uniquepartDescriptions, type, typeUnique});
      }
      this.ACTIVE_PART_TYPES_ICON();
    },
    async go(part) {
      if (!this.inPartsBasket(part)) {
        this.TOGGLE_SELECTION_SINGLE_PARTS_TYPES({ model: this.model, part});
      }
      await this.INQUIRY({request: this.basicCatalogRequest, page: 1, size: 25, group_by: 'manufacturer' });

    },
    showContent() {
      if (this.show == true ) 
        this.show = false;
      else 
         this.show = true
    },

    /****************  UNIQUE SECTION    ***********************/
    renderIconUnique(part){
      return this.inPartsBasketUnique(part)
        ? ('<i aria-hidden="true" class="v-icon material-icons">check_box</i>')
        : ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
    },
    inPartsBasketUnique(part) {
      return (this.$store.state.parts[this.model].findIndex((i => i.id === parseInt(part.id)))) !== -1
    },
    renderAllIconsUnique(parts){
      return this.inPartsBasketAllUnique(parts)
        ? ('<i aria-hidden="true" class="v-icon material-icons">indeterminate_check_box</i>')
        : ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
    },

    renderNotIconsUnique(){
      
      return ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
    },
    inPartsBasketAllUnique(uniquepartDescriptions){
      let count = 0;
      let partcount = 0
      uniquepartDescriptions.forEach(part => {
        const index = this.$store.state.parts[this.model].findIndex((i => i.id === parseInt(part.id)));
        if(index !== -1) {
          const partCountFinal = ++partcount
          count = partCountFinal
        }
      })
      if(count === uniquepartDescriptions.length){
        this.toggleSelectedIcon = true
        return true 
      } else {
        this.toggleSelectedIcon = false
        return false
      }
    },

    toggleSelectedUnique(part) {
      const type = 'unique'
      this.$emit("click", { model: this.model, part, type });
    },

    toggleAllSelectedUnique(uniquepartDescriptions) {
      if(this.toggleSelectedIcon === false) {
        const type = 2
        const typeUnique = true
        const parts = [];
        this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket',parts, uniquepartDescriptions, type, typeUnique});        
      } else if (this.toggleSelectedIcon === true){ 
        const type = 3
        const typeUnique = true
        const parts = []
        this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket', parts, uniquepartDescriptions, type, typeUnique});
      }
      this.ACTIVE_PART_TYPES_ICON();
    },

    async uniquePartDescriptions(parts){
      const groups = this.onlyGroups.find(g => g.id === parts[0].group.id )

      const groupRequest = {
        vehicle: this.vehicleForInquiry,
        partGroups: [{
          id: groups.id,
          name: groups.name,
          engineCode: groups.engineCode
        }]
      }
      const response = await this.GET_UNIQUE_PART_DESCRIPTIONS(groupRequest)
      this.uniquepartDescriptions = response.data.items

      if(this.totalPartBasketCount > 0){
        this.RESET_PARTS_TYPES();
        this.toggleAllSelectedUnique(this.uniquepartDescriptions)
      }
      this.showUniqueParts = true
      
    },
    resetUniquePartDescriptions(){
      this.uniquepartDescriptions = [];
      this.RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY();
      this.showUniqueParts = false
    }
  }
};
</script>
<style lang="stylus">
  .table {
    display: table
  }
  .group {
    display: flex
  }

  .toogleAllParts {
    cursor: pointer
  }

  .cardTitle{
    width: 400px
    justify-content: flex-start;
  } 
</style>